<template lang='pug'>
    div
        ElectricalPDSensorSelectorLinks
        div.fullwidth(v-if="$route.params.lang == 'en'")

            section.title-container
                h1.product-title HFCT-50
                h2.product-subtitle Split-Core HFCT for Electrical PD Measurement

            section.margin-bottom
                .column-container
                    .column.center-content
                        picture.main-product-picture
                            source(type='image/webp', srcset='@/assets/photos/HFCT-50.webp')
                            img( src='@/assets/photos/HFCT-50.png', width="70%", alt='PD Sensor HFCT-50', title='PD Sensor HFCT-50')
                    .column.factsandbluebox
                        .factbox
                            span.headline Key Features:
                            ul
                                li Contactless and inductive PD measurement
                                li Fits for up to 50 mm cables
                                li Also available for 90 mm cables on request: HFCT-90
                                li Bandwidth: 1 MHz ... 52 MHz
                                li Split-core design enables easy installation
                                li Integrated measurement load and overvoltage protection for maximum safety of the connected measuring device
                        .bluebox
                            Downloadlink(text='Datasheet (pdf, english)', link="/pdf/Datasheet HFCT-50.pdf")
                            Maillink(to='support@bss-hs.de', sub='HFCT-50', text='Contact Us', size=30, strokeWidth=2)
                            Sitelink(to="/en/products/pdm-600", text='PD Monitoring System PDM-600')
                            Sitelink(to="/en/products/pdm-80", text='PD Monitoring System PDM-80')
                            Sitelink(to="/en/products/pdm-600-mobile", text='PDM-600-Mobile')
                        
            section.margin-bottom
                p The HFCT-50 sensor is used to reliably transfer electrical partial discharge pulses from the test object to the PD measurement system. The HFCT allows highly sensitive detection of weak PD signals, while unwanted 50 Hz components are inherently suppressed due to its frequency-selective design. 
                p The sensor supports partial discharge measurements in the frequency range from 1 MHz to 52 MHz. Its split-core design enables easy installation without the need to disconnect or dismount the conductor under test.


        div.fullwidth(v-if="$route.params.lang == 'de'")

            section.title-container
                h1.product-title HFCT-50
                h2.product-subtitle Stromwandler mit Split-Core-Design für die elektrische TE-Messung

            section.margin-bottom
                .column-container
                    .column.center-content
                        picture.main-product-picture
                            source(type='image/webp', srcset='@/assets/photos/HFCT-50.webp')
                            img( src='@/assets/photos/HFCT-50.png', width="70%", alt='TE-Sensor HFCT-50', title='TE-Sensor HFCT-50')
                    .column.factsandbluebox
                        .factbox
                            span.headline Highlights:
                            ul
                                li Kontaktlose, induktive TE-Messung
                                li Bis zu 50 mm Kabeldurchmesser
                                li Auf Anfrage auch für Kabeldurchmesser bis zu 90 mm verfügbar: HFCT-90
                                li Bandbreite: 1 MHz ... 52 MHz
                                li Einfache Installation durch Split-Core-Design
                                li Integrierter Messwiderstand und Überspannungsschutz für maximale Sicherheit des angeschlossenen Messgeräts
                        .bluebox
                            Downloadlink(text='Datenblatt (pdf, englisch)', link="/pdf/Datasheet HFCT-50.pdf")
                            Maillink(to='support@bss-hs.de', sub='HFCT-50', text='Kontakt', size=30, strokeWidth=2)
                            Sitelink(to="/de/products/pdm-600", text='TE-Monitoringsystem PDM-600')
                            Sitelink(to="/de/products/pdm-80", text='TE-Monitoringsystem PDM-80')
                            Sitelink(to="/de/products/pdm-600-mobile", text='PDM-600-Mobile')
                    
            section.margin-bottom
                p Der HFCT-50 Sensor wird verwendet, um elektrische Teilentladungsimpulse eines Prüflings zuverlässig an ein TE-Messsystem zu übertragen. Der Sensor ermöglicht eine sensitive Erfassung auch schwacher TE-Signale, während unerwünschte 50-Hz-Komponenten aufgrund seines frequenzselektiven Aufbaus nicht übertragen werden. 
                p Mit dem Sensor können TE-Messungen im Frequenzbereich von 1 MHz bis 52 MHz durchgeführt werden. Das geteilte Kern-Design (Split-Core) ermöglicht eine einfache Installation, ohne den zu prüfenden Leiter demontieren zu müssen.

</template>

<script>
export default {
    meta: {
        de: {
            title: "BSS | HFCT-50",
            description:
                "Stromwandler mit Split-Core-Design für die elektrische TE-Messung",
        },
        en: {
            title: "BSS | HFCT-50",
            description:
                "Split-Core HFCT for Electrical PD Measurement",
        },
    },
};
</script>

<style scoped lang='sass'>
</style>